import request from '../request'
// import { USER_INFO } from '@/store/mutation-types'
// import storage from 'store'

// const userInfo = storage.get(USER_INFO)

export default {
  login(parameter) {
    return request({
      url: 'guard-person/login',
      method: 'post',
      data: parameter,
    })
  },
  getGuardSchedule(params) {
    return request({
      url: 'guard-schedule',
      method: 'get',
      params: params,
    })
  },
  editInfo(params) {
    return request({
      url: 'guard-person/update',
      method: 'post',
      data: params,
      params: { id: params.id },
    })
  },
  getCheckList(params) {
    return request({
      url: 'guard-schedule/calendar',
      method: 'get',
      params: params,
    })
  },
  getArRank(params) {
    return request({
      url: 'rank/ar',
      method: 'get',
      params: params,
    })
  },
  getYizhanRank(params) {
    return request({
      url: 'rank/yizhan',
      method: 'get',
      params: params,
    })
  },
}
